const useAppMenu = () => {
  const appMenu = {
    sections: [
      {
        label: 'Dashboard',
        links: [
          {
            label: 'Dashboard',
            path: '/',
          },
        ],
      },
      {
        label: 'Products',
        links: [
          {
            label: 'All Products',
            path: '/products',
          },
          {
            label: 'Catalogs',
            path: '/catalogs',
          },
          {
            label: 'Pricesheets',
            path: '/pricesheets',
          },
        ],
      },
      {
        label: 'Shipping',
        links: [
          {
            label: 'Regions',
            path: '/shipping/regions',
          },
          {
            label: 'Carriers',
            path: '/shipping/carriers',
          },
          {
            label: 'Rates',
            path: '/shipping/rates',
          },
        ],
      },
      {
        label: 'Mailing Lists',
        links: [
          {
            label: 'Mailing List',
            path: '/mailinglist',
          },
        ],
      },
      {
        label: 'Orders',
        links: [
          {
            label: 'Order Details',
            path: '/orders',
          },
          {
            label: 'Profit Calculator',
            path: '/orders/profitcalculator',
          },
        ],
      },
      {
        label: 'Vendors',
        links: [
          {
            label: 'Vendors',
            path: '/vendors',
          },
        ],
      },
      {
        label: 'Settings',
        links: [
          {
            label: 'Shopify',
            path: '',
          },
          {
            label: 'Hubspot',
            path: '',
          },
          {
            label: 'Messaging',
            path: '',
          },
        ],
      },
    ],
  };

  return appMenu;
};

export default useAppMenu;
